export var gql = String.raw;